/**
 * @desc 通过sku列表获取spu和军团信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmSkuProductLineAndCorpsRpcDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getProductLineAndCorpsBySkuNoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
